import axios from '@dap/shared-utils/http';

export default {
    getAdTiktokDict: () => axios.get('/dapper/api/tiktok_ad/dict'),
};
